import { memo } from 'react';

import type { Color } from '@didaskill/types/web';

type StarsOrnamentProps = {
  colorGroup: Color;
};

const StarsOrnamentBase = ({ colorGroup }: StarsOrnamentProps) => {
  return (
    <svg
      width="300"
      height="141"
      viewBox="0 0 300 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M286.448 49.695C286.981 48.254 289.019 48.254 289.552 49.695L290.977 53.5451C291.145 53.9982 291.502 54.3554 291.955 54.523L295.805 55.9477C297.246 56.4809 297.246 58.5191 295.805 59.0523L291.955 60.477C291.502 60.6446 291.145 61.0018 290.977 61.4549L289.552 65.305C289.019 66.746 286.981 66.746 286.448 65.305L285.023 61.4549C284.855 61.0018 284.498 60.6446 284.045 60.477L280.195 59.0523C278.754 58.5191 278.754 56.4809 280.195 55.9477L284.045 54.523C284.498 54.3554 284.855 53.9982 285.023 53.5451L286.448 49.695Z"
        fill={colorGroup[50]}
      />
      <path
        d="M49.4477 120.695C49.9809 119.254 52.0191 119.254 52.5523 120.695L53.977 124.545C54.1446 124.998 54.5018 125.355 54.9549 125.523L58.805 126.948C60.246 127.481 60.246 129.519 58.805 130.052L54.9549 131.477C54.5018 131.645 54.1446 132.002 53.977 132.455L52.5523 136.305C52.0191 137.746 49.9809 137.746 49.4477 136.305L48.023 132.455C47.8554 132.002 47.4982 131.645 47.0451 131.477L43.195 130.052C41.754 129.519 41.754 127.481 43.195 126.948L47.0451 125.523C47.4982 125.355 47.8554 124.998 48.023 124.545L49.4477 120.695Z"
        fill={colorGroup[50]}
      />
      <path
        d="M277.413 104.492C278.302 102.09 281.698 102.09 282.587 104.492L284.962 110.909C285.241 111.664 285.836 112.259 286.591 112.538L293.008 114.913C295.41 115.802 295.41 119.198 293.008 120.087L286.591 122.462C285.836 122.741 285.241 123.336 284.962 124.091L282.587 130.508C281.698 132.91 278.302 132.91 277.413 130.508L275.038 124.091C274.759 123.336 274.164 122.741 273.409 122.462L266.992 120.087C264.59 119.198 264.59 115.802 266.992 114.913L273.409 112.538C274.164 112.259 274.759 111.664 275.038 110.909L277.413 104.492Z"
        fill={colorGroup[200]}
      />
      <path
        d="M17.4128 64.4917C18.3015 62.09 21.6985 62.09 22.5872 64.4917L24.9616 70.9086C25.241 71.6636 25.8364 72.259 26.5914 72.5384L33.0083 74.9128C35.41 75.8015 35.41 79.1985 33.0083 80.0872L26.5914 82.4616C25.8364 82.741 25.241 83.3364 24.9616 84.0914L22.5872 90.5083C21.6985 92.91 18.3015 92.91 17.4128 90.5083L15.0384 84.0914C14.759 83.3364 14.1636 82.741 13.4086 82.4616L6.99174 80.0872C4.59004 79.1985 4.59004 75.8015 6.99174 74.9128L13.4086 72.5384C14.1636 72.259 14.759 71.6636 15.0384 70.9086L17.4128 64.4917Z"
        fill={colorGroup[100]}
      />
      <path
        d="M248.93 6.09339C249.641 4.17202 252.359 4.17203 253.07 6.09339L254.969 11.2268C255.193 11.8309 255.669 12.3072 256.273 12.5307L261.407 14.4303C263.328 15.1412 263.328 17.8588 261.407 18.5697L256.273 20.4693C255.669 20.6928 255.193 21.1691 254.969 21.7732L253.07 26.9066C252.359 28.828 249.641 28.828 248.93 26.9066L247.031 21.7732C246.807 21.1691 246.331 20.6928 245.727 20.4693L240.593 18.5697C238.672 17.8588 238.672 15.1412 240.593 14.4303L245.727 12.5307C246.331 12.3072 246.807 11.8309 247.031 11.2268L248.93 6.09339Z"
        fill={colorGroup[100]}
      />
      <path
        d="M52.9303 22.0934C53.6412 20.172 56.3588 20.172 57.0697 22.0934L58.9693 27.2268C59.1928 27.8309 59.6691 28.3072 60.2732 28.5307L65.4066 30.4303C67.328 31.1412 67.328 33.8588 65.4066 34.5697L60.2732 36.4693C59.6691 36.6928 59.1928 37.1691 58.9693 37.7732L57.0697 42.9066C56.3588 44.828 53.6412 44.828 52.9303 42.9066L51.0307 37.7732C50.8072 37.1691 50.3309 36.6928 49.7268 36.4693L44.5934 34.5697C42.672 33.8588 42.672 31.1412 44.5934 30.4303L49.7268 28.5307C50.3309 28.3072 50.8072 27.8309 51.0307 27.2268L52.9303 22.0934Z"
        fill={colorGroup[200]}
      />
    </svg>
  );
};

StarsOrnamentBase.displayName = 'StarsOrnament';

export const StarsOrnament = memo(StarsOrnamentBase);
